import type { PastAttempt } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import { useRouter } from "next/compat/router";
import useSWR from "swr";

const usePracticeExamAttempts = () => {
	const { slug } = (useRouter()?.query ?? {}) as {
		slug: string;
	};

	const { userId } = useAuth();

	const res = useSWR<PastAttempt[]>(
		slug && userId && `/courses/${slug}/exams/practice/attempts`,
	);

	return { pastAttempts: res.data, ...res };
};

export default usePracticeExamAttempts;
